import { SectionMessage } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { useVatDeclarations } from '../../context/vatDeclarationsContext'
import { CorrectionBannerMessage } from './elements/CorrectionBannerMessage'

export const VatDeclarationsCorrectionBanner = () => {
  const { t } = useTranslation()
  const { closeCorrectionBanner } = useVatDeclarations()

  return (
    <SectionMessage
      closable
      data-testid={LocalStorageKeys.VatDeclarationsCorrectionBanner}
      onClose={closeCorrectionBanner}
      title={t('vat_declarations.correction_banner.title')}
      variant="warning"
    >
      <CorrectionBannerMessage />
    </SectionMessage>
  )
}
